import { zetApi } from '@zet/network'

import { ILeadCount } from '../types'

export async function getLeadCount() {
  const { data } = await zetApi.get<ILeadCount>('userForm/getLeadCount/v2')
  return data?.data
}
